export default __webpack_public_path__ + "static/media/optimism.4538ec28.png";